<template>
  <h1>Friends</h1>
</template>

<script>
export default {
  name: 'Friends',
};
</script>
